import { Component, OnInit } from '@angular/core';
import { FuiModal } from 'ngx-fomantic-ui';
import {  ICreateDirectoryModalContext, IListItemQueryResult } from '../../models/interface';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { finalize } from 'rxjs/operators';
import { FileManagerService } from '../../services/file-manager.service';

@Component({
    selector: 'ps-create-directory-modal',
    templateUrl: './create-directory-modal.component.html',
    styleUrls: ['./create-directory-modal.component.css']
})
export class CreateDirectoryModalComponent implements OnInit {
    context: ICreateDirectoryModalContext;
    form: FormGroup;

    loading: boolean = false;

    constructor(public modal: FuiModal<ICreateDirectoryModalContext, IListItemQueryResult, void>,
        private _fileManager: FileManagerService,
        private formBuilder: FormBuilder) {

    }

    ngOnInit(): void {
        this.context = this.modal.context;

        this.form = this.formBuilder.group({
            'directoryName': ['', Validators.required]
        });
    }

    onCreate() {
        this.loading = true;
        let directoryName = this.form.get('directoryName').value;
        this._fileManager.createDirectory({
            name: directoryName,
            contextName: this.context.context.name,
            directoryId: this.context.directoryId
        })
            .pipe(finalize(() => {
                this.loading = false;
            }))
            .subscribe((directoryId: string) => {
                let directory: IListItemQueryResult = {
                    id: directoryId,
                    name: directoryName,
                    originalName: directoryName,
                    displayName: directoryName,
                    isDirectory: true,
                    extension: '',
                    directoryId: this.context.directoryId,
                    contextId: this.context.context.id
                };
                this.modal.approve(directory);
            });
    }

    getField(name) {
        return this.form.get(name);
    }

    fieldHasError(field) {
        return (field.invalid && (field.dirty || field.touched));
    }
}

